import React from "react";

export default function Subheader({ text }) {
  return (
    <div
      className={`cps-card__header cps-padding-left-24 cps-bg-gray-4`}
      style={{ fontSize: "1.6rem" }}
    >
      {text}
    </div>
  );
}
